import { SnackbarProvider, closeSnackbar } from 'notistack';
import { CloseIcon } from '../../Styles';

const Notification = () => (
  <SnackbarProvider
    anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
    disableWindowBlurListener
    autoHideDuration={4000}
    variant="error"
    action={() => <CloseIcon onClick={() => closeSnackbar()} />}
  />
);

export default Notification;
